import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";

export function PostHogSync() {
  const { user, userData, loading } = useAuth();

  useEffect(() => {
    if (!loading && user && userData && userData.tenantId) {
      // Get the auth token for the request
      user.getIdToken().then((token) => {
        // Sync user with PostHog server-side via our backend API
        fetch(`${import.meta.env.VITE_API_URL}/api/auth/sync-posthog`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            userId: user.uid,
            email: user.email,
            displayName: userData.displayName,
            role: userData.role,
            tenantId: userData.tenantId,
          }),
        })
          .then(() => {
           
          })
          .catch((err) => {
            console.error("❌ Failed to sync with PostHog server:", err);
          });
      });
    }
  }, [user, userData, loading]);

  return null;
}
